import { ERROR_CODES, METHOD_STATUSES } from "@modules/sdk/constants";
import { checkSubscribers, promiseWithTimeout } from "@modules/sdk/helpers";
import SdkError from "@modules/sdk/methods/SdkError";
import SdkMethodsCollector from "@modules/sdk/methods/SdkMethodsCollector";
import type { SdkMethodsInterface } from "@modules/sdk/methods/SdkMethodsInterface";
import { Success } from "@modules/sdk/types";

import { GIFT_REGISTRY_SDK_METHODS } from "./constants";
import OpenGiftRegistryFormModalSdkMethodPayload from "./methods/OpenGiftRegistryFormModalSdkMethodPayload";

class GiftRegistrySdkMethods
    implements SdkMethodsInterface<GIFT_REGISTRY_SDK_METHODS>
{
    constructor(private readonly _collector: SdkMethodsCollector) {}

    public openGiftRegistryFormModal() {
        return promiseWithTimeout(
            new Promise<Success>((resolve, reject) => {
                checkSubscribers(
                    GIFT_REGISTRY_SDK_METHODS.OPEN_GIFT_REGISTRY_FORM_MODAL,
                    reject
                );

                this._collector.notifySubscribers(
                    new OpenGiftRegistryFormModalSdkMethodPayload(
                        () => resolve({ status: METHOD_STATUSES.SUCCESS }),
                        () => reject(new SdkError(ERROR_CODES.GENERAL_ERROR))
                    )
                );
            })
        );
    }
}

export default GiftRegistrySdkMethods;
